import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReadingMore: false,
      showReadMore: false,
    };
    this.readMore = this.readMore.bind(this);
  }

  componentDidMount() {
    this.setShowReadMore();
  }

  setShowReadMore() {
    // Added 1 to clientHeight because in Safari 12.1 there is a rounding error leading
    // scrollHeight to be bigger than the clientHeight by 1 and so showReadMore is true
    if (this.notesElement !== undefined) {
      this.setState({
        showReadMore: this.notesElement.scrollHeight > this.notesElement.clientHeight + 1,
      });
    }
  }

  readMore() {
    this.setState((prevState) => ({ isReadingMore: !prevState.isReadingMore }));
  }

  renderDateAndReadMore() {
    const { isReadingMore, showReadMore } = this.state;
    const { feedback } = this.props;
    if (feedback.note && showReadMore) {
      return (
        <div className="align">
          <a
            className="body-text-4"
            tabIndex={0}
            role="link"
            onClick={this.readMore}
          >
            {' '}
            {isReadingMore ? 'Read Less' : 'Read More'}
          </a>
          <span className="body-text-4 end no-wrap muted-gray-text">
            {feedback.updated_at}
          </span>
        </div>
      );
    }
    return (
      <div className="align">
        <span className="body-text-4 end no-wrap muted-gray-text">
          {feedback.updated_at}
        </span>
      </div>
    );
  }

  render() {
    const { feedback, canCreateFeedback } = this.props;
    const { isReadingMore, showReadMore } = this.state;
    return (
      <div
        className={`proposal-feedback-container can-create-${canCreateFeedback}`}
        key={`feedback-${feedback.email}`}
      >
        <div className="feedback-body">
          <div className="avatar">{feedback.initials}</div>
          <div className="feedback-content">
            <div className="feedback">
              <div className="user-name">{feedback.name || feedback.email}</div>
              { feedback.note
                && (
                <div
                  className={`user-feedback ${isReadingMore ? 'show' : 'overflow'}`}
                  ref={(el) => { this.notesElement = el; }}
                >
                  {feedback.note}
                </div>
                )}
              { showReadMore
                && (
                <div
                  className="reading-more"
                  onClick={this.readMore}
                  tabIndex={0}
                  role="button"
                >
                  {isReadingMore ? 'Read Less' : 'Read More'}
                </div>
                )}
            </div>
            <div className={`status ${feedback.consultant_fit ? feedback.consultant_fit : ''}`}>
              {feedback.consultant_fit ? feedback.consultant_fit.toUpperCase() : ''}
            </div>
          </div>
        </div>
        <div className="feedback-footer">
          <div className="timestamp">{feedback.updated_at}</div>
        </div>
      </div>
    );
  }
}

Feedback.propTypes = {
  canCreateFeedback: PropTypes.bool.isRequired,
  feedback: PropTypes.shape({}).isRequired,
};

export default Feedback;
